export default "__VITE_ASSET__DfDEL$Nc__"